import get from 'lodash.get';

const getVariables = (rootState) => get(rootState, 'ws.template.meta.variables', {});

export default getVariables;
